import { gql } from '@apollo/client';
import Attachment from './attachment.fragment';

export default gql`
  fragment LandingPageFolderLevel3 on Folder {
    id
    name
    attachments {
      ...LandingPageAttachment
    }
  }

  fragment LandingPageFolderLevel2 on Folder {
    id
    name
    attachments {
      ...LandingPageAttachment
    }
    folders {
      ...LandingPageFolderLevel3
    }
  }

  fragment LandingPageFolderLevel1 on Folder {
    id
    name
    attachments {
      ...LandingPageAttachment
    }
    folders {
      ...LandingPageFolderLevel2
    }
  }

  fragment LandingPageAttachments on Attachments {
    owner
    application
    parentType
    parentId
    attachments {
      ...LandingPageAttachment
    }
    folders {
      ...LandingPageFolderLevel1
    }
  }
  ${Attachment}
`;
